import type { Severity } from '../../types/api'

/**
 * The tones of the one pill style (DEC-193 decision 2), held apart from `Badge.tsx` so
 * that file exports components only (fast refresh). The colours are tokens in index.css:
 * edges `--pill-edge-*`, dots `mark-*`, the amber dot and its ring `--pill-*-warn`.
 */
export type PillTone =
  | 'critical'
  | 'high'
  | 'medium'
  | 'low'
  | 'warn'
  | 'running'
  | 'waiting'
  | 'scheduled'
  | 'stopped'
  | 'success'
  | 'neutral'

export const PILL_EDGE: Record<PillTone, string> = {
  critical: 'border-pill-critical',
  high: 'border-pill-high',
  medium: 'border-pill-medium',
  low: 'border-pill-low',
  warn: 'border-pill-warn',
  running: 'border-pill-running',
  waiting: 'border-pill-neutral',
  scheduled: 'border-pill-neutral',
  stopped: 'border-pill-neutral',
  success: 'border-pill-success',
  neutral: 'border-pill-neutral',
}

/** The dot of each tone. Waiting is a hollow ring (Scheduled dashed); Paused and
 *  Finished with gaps are an amber fill inside a darker ring. */
export const PILL_DOT: Record<PillTone, string> = {
  critical: 'bg-mark-critical',
  high: 'bg-mark-high',
  medium: 'bg-mark-medium',
  low: 'bg-mark-low',
  warn: 'bg-pill-dot-warn border-[1.5px] border-pill-ring-warn',
  running: 'bg-mark-running',
  waiting: 'bg-transparent border-[1.5px] border-mark-idle',
  scheduled: 'bg-transparent border-[1.5px] border-dashed border-mark-idle',
  stopped: 'bg-mark-idle',
  success: 'bg-mark-success',
  neutral: 'bg-mark-idle',
}

export const SEVERITY_LABEL: Record<Severity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
}

